import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { ListNavigationModule } from '@spartacus/storefront';
import { KnBrRequestQuoteListingComponent } from './kn-br-request-quote-listing/kn-br-request-quote-listing.component';
import { KnBrRequestQuoteListingDetailsComponent } from './kn-br-request-quote-listing-details/kn-br-request-quote-listing-details.component';

@NgModule({
  declarations: [],
  imports: [CommonModule,FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    ListNavigationModule,
    I18nModule,
    ConfigModule.withConfig({
            cmsComponents: {
                quoteRequestsListComponent: {
                    component: KnBrRequestQuoteListingComponent
                },
                quoteRequestDetailsItemsComponent: {
                    component: KnBrRequestQuoteListingDetailsComponent
                }
            },
            KnBrRequestQuoteListingDetailsComponent
        } as CmsConfig),],
})
export class KnBrRequestQuoteListingModule {}
